import { render, staticRenderFns } from "./MakeAnEntryTip.vue?vue&type=template&id=38129551&lang=pug&"
import script from "./MakeAnEntryTip.vue?vue&type=script&lang=js&"
export * from "./MakeAnEntryTip.vue?vue&type=script&lang=js&"
import style0 from "./MakeAnEntryTip.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports